<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-bottom">
      <Cell :flex="1">
        <Select v-model="filter.categoryId" :datas="categoryList" key-name="id" title-name="name" 
                :null-option="{title: '全部类别'}" @change="loadData" style="width: 150px"/>
        <Select v-model="filter.status" :datas="statusList" key-name="id" title-name="name" 
                :null-option="{title: '全部状态'}" @change="loadData" style="width: 120px; margin-left: 10px"/>
      </Cell>
      <Cell>
        <Button color="primary" @click="openCreate" icon="h-icon-plus">新增存货</Button>
      </Cell>
    </Row>
    <Table :datas="itemList" :loading="loading" :columns="columns">
      <template v-slot:stockQuantity="{data}">
        <span :class="getStockClass(data)">{{ data.stockQuantity }}</span>
      </template>
      <template v-slot:status="{data}">
        <span :class="data.status === 1 ? 'green-color' : 'gray-color'">
          {{ data.status === 1 ? '启用' : '停用' }}
        </span>
      </template>
      <template v-slot:action="{data}">
        <Button text color="primary" @click="openEdit(data)">编辑</Button>
        <Button text color="primary" @click="openStockIn(data)">入库</Button>
        <Button text color="primary" @click="openStockOut(data)">出库</Button>
        <Button text color="red" @click="remove(data)">删除</Button>
      </template>
    </Table>

    <!-- 新增/编辑弹窗 -->
    <Modal v-model="modalVisible" :title="modalTitle" :close-on-mask="false">
      <Form ref="form" :label-width="100" :rules="rules" :model="formData">
        <FormItem label="存货编码" prop="code">
          <Input v-model="formData.code" placeholder="请输入存货编码"/>
        </FormItem>
        <FormItem label="存货名称" prop="name">
          <Input v-model="formData.name" placeholder="请输入存货名称"/>
        </FormItem>
        <FormItem label="所属类别">
          <Select v-model="formData.categoryId" :datas="categoryList" key-name="id" title-name="name" 
                  :null-option="{title: '请选择类别'}"/>
        </FormItem>
        <FormItem label="规格型号">
          <Input v-model="formData.specification" placeholder="请输入规格型号"/>
        </FormItem>
        <FormItem label="计量单位">
          <Input v-model="formData.unit" placeholder="请输入计量单位"/>
        </FormItem>
        <FormItem label="参考进价">
          <Input v-model="formData.purchasePrice" type="number" placeholder="请输入参考进价"/>
        </FormItem>
        <FormItem label="参考售价">
          <Input v-model="formData.salePrice" type="number" placeholder="请输入参考售价"/>
        </FormItem>
        <FormItem label="库存下限">
          <Input v-model="formData.minStock" type="number" placeholder="请输入库存下限"/>
        </FormItem>
        <FormItem label="库存上限">
          <Input v-model="formData.maxStock" type="number" placeholder="请输入库存上限"/>
        </FormItem>
        <FormItem label="状态">
          <SwitchList v-model="formData.status" :datas="[{title: '启用', key: 1}, {title: '停用', key: 0}]"/>
        </FormItem>
        <FormItem label="备注">
          <Input v-model="formData.remark" placeholder="请输入备注"/>
        </FormItem>
      </Form>
      <template v-slot:footer>
        <Button color="primary" @click="save" :loading="saving">保存</Button>
        <Button @click="modalVisible = false">取消</Button>
      </template>
    </Modal>

    <!-- 入库弹窗 -->
    <Modal v-model="stockInVisible" title="入库操作" :close-on-mask="false">
      <Form ref="stockInForm" :label-width="100" :rules="stockRules" :model="stockData">
        <FormItem label="存货名称">
          <Input v-model="stockData.itemName" readonly/>
        </FormItem>
        <FormItem label="入库数量" prop="quantity">
          <Input v-model="stockData.quantity" type="number" placeholder="请输入入库数量"/>
        </FormItem>
        <FormItem label="入库单价" prop="unitPrice">
          <Input v-model="stockData.unitPrice" type="number" placeholder="请输入入库单价"/>
        </FormItem>
        <FormItem label="入库日期" prop="billDate">
          <DatePicker v-model="stockData.billDate" placeholder="请选择入库日期"/>
        </FormItem>
        <FormItem label="业务类型">
          <Select v-model="stockData.bizType" :datas="[{title: '采购入库', key: 'Purchase'}, {title: '盘点入库', key: 'Check'}]"/>
        </FormItem>
        <FormItem label="摘要">
          <Input v-model="stockData.digest" placeholder="请输入摘要"/>
        </FormItem>
      </Form>
      <template v-slot:footer>
        <Button color="primary" @click="doStockIn" :loading="stockLoading">确认入库</Button>
        <Button @click="stockInVisible = false">取消</Button>
      </template>
    </Modal>

    <!-- 出库弹窗 -->
    <Modal v-model="stockOutVisible" title="出库操作" :close-on-mask="false">
      <Form ref="stockOutForm" :label-width="100" :rules="stockRules" :model="stockData">
        <FormItem label="存货名称">
          <Input v-model="stockData.itemName" readonly/>
        </FormItem>
        <FormItem label="出库数量" prop="quantity">
          <Input v-model="stockData.quantity" type="number" placeholder="请输入出库数量"/>
        </FormItem>
        <FormItem label="出库单价" prop="unitPrice">
          <Input v-model="stockData.unitPrice" type="number" placeholder="请输入出库单价"/>
        </FormItem>
        <FormItem label="出库日期" prop="billDate">
          <DatePicker v-model="stockData.billDate" placeholder="请选择出库日期"/>
        </FormItem>
        <FormItem label="业务类型">
          <Select v-model="stockData.bizType" :datas="[{title: '销售出库', key: 'Sale'}, {title: '盘点出库', key: 'Check'}]"/>
        </FormItem>
        <FormItem label="摘要">
          <Input v-model="stockData.digest" placeholder="请输入摘要"/>
        </FormItem>
      </Form>
      <template v-slot:footer>
        <Button color="primary" @click="doStockOut" :loading="stockLoading">确认出库</Button>
        <Button @click="stockOutVisible = false">取消</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import inventory from '@/api/inventory';
import manba from 'manba';

export default {
  name: "InventoryItem",
  props: {
    accountSetsId: Number
  },
  data() {
    return {
      loading: false,
      itemList: [],
      categoryList: [],
      filter: {
        categoryId: null,
        status: null
      },
      statusList: [
        { id: 1, name: '启用' },
        { id: 0, name: '停用' }
      ],
      columns: [
        { title: '存货编码', key: 'code', width: 100 },
        { title: '存货名称', key: 'name' },
        { title: '规格型号', key: 'specification' },
        { title: '单位', key: 'unit', width: 60 },
        { title: '库存数量', slot: 'stockQuantity', width: 100 },
        { title: '库存金额', key: 'stockAmount', width: 120 },
        { title: '参考进价', key: 'purchasePrice', width: 100 },
        { title: '参考售价', key: 'salePrice', width: 100 },
        { title: '状态', slot: 'status', width: 80 },
        { title: '操作', slot: 'action', width: 200 }
      ],
      modalVisible: false,
      modalTitle: '新增存货',
      formData: {
        id: null,
        code: '',
        name: '',
        categoryId: null,
        specification: '',
        unit: '件',
        purchasePrice: 0,
        salePrice: 0,
        minStock: 0,
        maxStock: 0,
        status: 1,
        remark: ''
      },
      rules: {
        code: [{ required: true, message: '请输入存货编码' }],
        name: [{ required: true, message: '请输入存货名称' }]
      },
      saving: false,
      stockInVisible: false,
      stockOutVisible: false,
      stockData: {
        itemId: null,
        itemName: '',
        quantity: 0,
        unitPrice: 0,
        billDate: manba().format(),
        bizType: '',
        digest: ''
      },
      stockRules: {
        quantity: [{ required: true, message: '请输入数量' }],
        unitPrice: [{ required: true, message: '请输入单价' }],
        billDate: [{ required: true, message: '请选择日期' }]
      },
      stockLoading: false
    };
  },
  watch: {
    accountSetsId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadCategory();
          this.loadData();
        }
      }
    }
  },
  methods: {
    loadCategory() {
      inventory.category.listByAccountSetsId(this.accountSetsId)
        .then(res => {
          this.categoryList = res.data || [];
        });
    },
    loadData() {
      this.loading = true;
      inventory.item.listByAccountSetsId(this.accountSetsId)
        .then(res => {
          let list = res.data || [];
          if (this.filter.categoryId) {
            list = list.filter(item => item.categoryId === this.filter.categoryId);
          }
          if (this.filter.status !== null) {
            list = list.filter(item => item.status === this.filter.status);
          }
          this.itemList = list;
        })
        .catch(() => {
          this.itemList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getStockClass(data) {
      if (data.stockQuantity <= data.minStock) return 'red-color';
      if (data.stockQuantity >= data.maxStock) return 'yellow-color';
      return '';
    },
    openCreate() {
      this.modalTitle = '新增存货';
      this.formData = {
        id: null,
        code: '',
        name: '',
        categoryId: null,
        specification: '',
        unit: '件',
        purchasePrice: 0,
        salePrice: 0,
        minStock: 0,
        maxStock: 0,
        status: 1,
        remark: ''
      };
      this.modalVisible = true;
    },
    openEdit(data) {
      this.modalTitle = '编辑存货';
      this.formData = { ...data };
      this.modalVisible = true;
    },
    save() {
      this.$refs.form.validate().then(valid => {
        if (valid) {
          this.saving = true;
          const data = { ...this.formData, accountSetsId: this.accountSetsId };
          const request = data.id ? inventory.item.update(data) : inventory.item.create(data);
          request
            .then(() => {
              this.$Message.success('保存成功');
              this.modalVisible = false;
              this.loadData();
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },
    openStockIn(data) {
      this.stockData = {
        itemId: data.id,
        itemName: data.name,
        quantity: 0,
        unitPrice: data.purchasePrice || 0,
        billDate: manba().format(),
        bizType: 'Purchase',
        digest: '采购入库'
      };
      this.stockInVisible = true;
    },
    doStockIn() {
      this.$refs.stockInForm.validate().then(valid => {
        if (valid) {
          this.stockLoading = true;
          const data = {
            ...this.stockData,
            accountSetsId: this.accountSetsId,
            billType: 1,
            billNo: 'RK' + Date.now(),
            amount: this.stockData.quantity * this.stockData.unitPrice
          };
          inventory.record.stockIn(data)
            .then(() => {
              this.$Message.success('入库成功');
              this.stockInVisible = false;
              this.loadData();
            })
            .finally(() => {
              this.stockLoading = false;
            });
        }
      });
    },
    openStockOut(data) {
      this.stockData = {
        itemId: data.id,
        itemName: data.name,
        quantity: 0,
        unitPrice: data.salePrice || 0,
        billDate: manba().format(),
        bizType: 'Sale',
        digest: '销售出库'
      };
      this.stockOutVisible = true;
    },
    doStockOut() {
      this.$refs.stockOutForm.validate().then(valid => {
        if (valid) {
          this.stockLoading = true;
          const data = {
            ...this.stockData,
            accountSetsId: this.accountSetsId,
            billType: 2,
            billNo: 'CK' + Date.now(),
            amount: this.stockData.quantity * this.stockData.unitPrice
          };
          inventory.record.stockOut(data)
            .then(() => {
              this.$Message.success('出库成功');
              this.stockOutVisible = false;
              this.loadData();
            })
            .finally(() => {
              this.stockLoading = false;
            });
        }
      });
    },
    remove(data) {
      this.$Confirm('确定删除该存货吗？', '提示')
        .then(() => {
          inventory.item.delete(data.id)
            .then(() => {
              this.$Message.success('删除成功');
              this.loadData();
            });
        });
    }
  }
};
</script>
